import { render, staticRenderFns } from "./remindList.vue?vue&type=template&id=62565b4a&scoped=true&"
import script from "./remindList.vue?vue&type=script&lang=ts&"
export * from "./remindList.vue?vue&type=script&lang=ts&"
import style0 from "./remindList.vue?vue&type=style&index=0&id=62565b4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62565b4a",
  null
  
)

export default component.exports